import axios from "axios";
import { loadStripe } from "@stripe/stripe-js/pure";

// disable the advanced fraud signals telemetry (POST to m.stripe.com)
loadStripe.setLoadParameters({ advancedFraudSignals: false });

let stripePromise = null;

export function getStripe() {
  if (!stripePromise) {
    stripePromise = axios
      .get("/api/stripe/config")
      .then((response) =>
        loadStripe(
          response.data.publishableKey ||
            import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY
        )
      )
      .catch((error) => {
        // allow a retry on the next call
        stripePromise = null;
        throw error;
      });
  }
  return stripePromise;
}
